<template>
  <v-expansion-panel>
    <v-expansion-panel-header class="section-panel-header">
      <div class="d-flex align-center">
        <v-avatar color="primary" size="36" class="mr-3 panel-avatar">
          <v-icon dark small>contacts</v-icon>
        </v-avatar>
        <div>
          <div class="section-title">Contacts & Coordonnées</div>
          <div class="section-subtitle">Responsables du magasin par rôle</div>
        </div>
      </div>
      <template v-slot:actions>
        <v-chip x-small :color="allFilled ? 'success' : 'secondary'" dark class="mr-2">{{ contactCount }}</v-chip>
        <v-icon color="primary">$expand</v-icon>
      </template>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-row class="mt-2 px-2">
        <v-col
          v-for="(item, contactIndex) in contacts"
          :key="'contact-' + contactIndex"
          cols="12" sm="6" md="4"
        >
          <v-card outlined class="contact-card pa-4 fill-height" :class="{ 'contact-card--filled': isContactFilled(item) }">
            <div class="contact-type-label mb-3">
              <v-icon x-small :color="roleColor(item.idtypecontact)" class="mr-1">{{ roleIcon(item.idtypecontact) }}</v-icon>
              <span :style="{ color: `var(--v-${roleColor(item.idtypecontact)}-base)` }">{{ item.type }}</span>
              <v-spacer />
              <v-icon v-if="isContactFilled(item)" x-small color="success">check_circle</v-icon>
            </div>
            <v-row dense>
              <v-col cols="6">
                <v-text-field
                  v-model="item.nom"
                  :label="item.idtypecontact === 1 ? 'Nom *' : 'Nom'"
                  dense outlined hide-details="auto"
                  class="mb-2"
                  prepend-inner-icon="badge"
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="item.prenom"
                  :label="item.idtypecontact === 1 ? 'Prénom *' : 'Prénom'"
                  dense outlined hide-details="auto"
                  class="mb-2"
                />
              </v-col>
            </v-row>
            <v-text-field
              v-model="item.telephone"
              type="tel"
              counter="10"
              :rules="[rules.phoneCounter, rules.required]"
              label="Téléphone *"
              dense outlined hide-details="auto"
              class="mb-2"
              prepend-inner-icon="phone"
            />
            <v-text-field
              v-model="item.mail"
              :rules="[rules.required, rules.email]"
              type="email"
              label="Mail *"
              dense outlined hide-details="auto"
              prepend-inner-icon="email"
            />
          </v-card>
        </v-col>
      </v-row>
      <v-alert v-if="invalidContact" type="warning" dense text class="mt-4 mx-2" border="left">
        <strong>Champ requis</strong> — Veuillez préciser le prénom et le nom du chef de rayon.
      </v-alert>
      <v-row justify="center" class="mt-4">
        <v-col cols="auto">
          <v-btn color="primary" :disabled="invalidContact || isSaving" :loading="isSaving" @click="$emit('save')">
            <v-icon left small>save</v-icon>
            Enregistrer
          </v-btn>
        </v-col>
      </v-row>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
const ROLE_ICONS = {
  1: 'storefront',
  2: 'manage_accounts',
  3: 'support_agent',
}
const ROLE_COLORS = {
  1: 'primary',
  2: 'secondary',
  3: 'teal',
}

export default {
  name: 'ContactsSection',
  props: {
    contacts: { type: Array, default: () => [] },
    rules: { type: Object, required: true },
    isSaving: { type: Boolean, default: false },
  },
  computed: {
    contactCount () {
      const filled = this.contacts.filter(c => this.isContactFilled(c)).length
      return `${filled}/${this.contacts.length}`
    },
    allFilled () {
      return this.contacts.every(c => this.isContactFilled(c))
    },
    invalidContact () {
      return this.contacts.some(c => c.idtypecontact === 1 && (!c.nom || !c.prenom))
    },
  },
  methods: {
    isContactFilled (contact) {
      return !!(contact.nom && contact.prenom && contact.telephone && contact.mail)
    },
    roleIcon (idtypecontact) {
      return ROLE_ICONS[idtypecontact] || 'person'
    },
    roleColor (idtypecontact) {
      return ROLE_COLORS[idtypecontact] || 'primary'
    },
  },
}
</script>

<style lang="scss" scoped>
.contact-card {
  transition: border-color 0.2s, box-shadow 0.2s;

  &--filled {
    border-color: var(--v-success-base) !important;
    background: rgba(76, 175, 80, 0.03) !important;
  }
}
</style>
